/* eslint-disable no-template-curly-in-string */
import commons from "./commons/es"
import components from "./components/es"
import forms from "./forms/es"
import models from "./models/es"
import screens from "./screens/es"
import yup from "./yup/es"

export default {
  "bottomMenu" : {
    "home": "Hogar",
    "graph": "Grafico",
    "quickInput": "Entrada Rápida",
    "help": "Ayuda",
    "profile": "Perfil"
  },
  "common": {
    "ok": "OK!",
    "yes": "Sí",
    "cancel": "Cancelar",
    "back": "Atrás",
    "close": "Cerca",
    "next": "Siguiente",
    "done": "Hecho",
  },
  "errors": {
    "invalidEmail": "Dirección de correo electrónico no válida."
  },
  "welcomeScreen": {
    "poweredBy": "POWERED BY IGNITE",
    "readyForLaunch": "Ready for launch.",
    "continue": "CONTINUE"
  },
  "demoScreen": {
    "howTo": "HOW TO",
    "title": "What’s In This Stack?",
    "tagLine": "Congratulations, you’ve got a very advanced React Native app template here.  Take advantage of this boilerplate!",
    "reactotron": "Demo Reactotron",
    "demoList": "Demo List",
    "androidReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running, run adb reverse tcp:9090 tcp:9090 from your terminal, and reload the app.",
    "iosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "macosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "webReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app.",
    "windowsReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app."
  },
  "demoListScreen": {
    "title": "Demo List"
  },
  "errorScreen": {
    "title": "Something went wrong!",
    "friendlySubtitle": "This is the screen that your users will see in production when an error is thrown. You'll want to customize this message (located in `app/i18n/en.json`) and probably the layout as well (`app/screens/error`). If you want to remove this entirely, check `app/app.tsx` for the <ErrorBoundary> component.",
    "traceTitle": "Error from %{name} stack",
    "reset": "RESET APP"
  },

  "splashScreen": {
    "splashScreenTitle": "Aplicación de gestión de granjas camaroneras",
    "releaseTitle": "¿Qué hay de nuevo en {{version}}",
    "releaseMessage": "",
    "hashtag": "#HadirMembantu"
  },
  "onboardScreen": {
    "onboard1": "Bienvenidos a Jala",
    "onboard2": "Modo Sin Conexión",
    "onboard3": "Monitoreé las condiciones de su estanque donde quiera que esté",
    "onboard4": "Gestion Colaborativa de Granjas",
    "onboard5": "Actualizaciones y noticias sobre los precios del camarón",
    "onboard6": "Integrado con el dispositivo de calidad del agua Jala Baruno",
    "login": "Iniciar sesión",
    "register": "Registrarse",
    "justTry": "Solo quiero probar?",
    "tryDemo": "Prueba la demo"
  },
  "socialLoginScreen": {
    "socialLoginScreenTitle": "Aplicación de Gestión de Granjas de Camaron",
    "loginWithApple": "Iniciar sesión con Apple",
    "loginWithGoogle": "Iniciar sesión con Google",
    "loginWithFacebook": "Iniciar sesión con Facebook",
    "or": "O",
    "loginWithEmail": "Inicie sesión con su correo electrónico",
    "loginWithPhoneEmail": "Iniciar sesión con teléfono o correo electrónico"
  },
  "loginScreen": {
    "welcome": "Bienvenido",
    "loginSubtitle": "Inicie sesión con la dirección de correo electrónico registrada",
    "email": "Correo electrónico",
    "emailAddress": "Número de teléfono o dirección de correo electrónico",
    "password": "Contraseña",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "login": "Iniciar sesión",
    "failedAlert": "Error de inicio de sesion",
    "failedAlertSubtitle": "Asegúrese de que su número de teléfono/correo electrónico y contraseña sean correctos"
  },
  "passwordResetScreen": {
    "resetPassword": "Restablecer la contraseña",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "InputForgotPasswordEmail": "Ingrese su correo electrónico",
    "ButtonForgotPassword": "Enviar enlace de restablecimiento de contraseña",
    "forgotPasswordSubtitle": "Ingresa tu dirección de correo electrónico, y te enviaremos una guía con un enlace para restablecer la contraseña.",
    "guideTitle": "Se ha enviado la guía de reinicio",
    "guideMessage": "revisa tu correo electrónico para restablecer la contraseña.",
    "failedTitle": "No se pudo restablecer la contraseña",
    "errorMessage": "No podemos encontrar al usuario con ese correo electrónico.",

    "phoneModeButton": "Usar Número de Teléfono",
    "emailModeButton": "Usar Correo Electrónico",
    "sendOTPButton": "Enviar Código de Verificación",

    "forgotPasswordWithPhoneSubtitle": "Ingrese su número de teléfono, le enviaremos un código de verificación para restablecer su contraseña.",
    "inputOTPTitle": "Ingrese el código de verificación",
    "inputOTPSubtitle": "El código de verificación ha sido enviado al número {{phone}}. Por favor, ingrese el código de verificación a continuación para continuar. ¿No recibió el código de verificación?",
    "resendOTP": "Reenviar código",
    "inputNewPassword": "Ingrese su nueva contraseña",
    "successTitle": "Contraseña Actualizada Exitosamente",
    "successSubtitle": "Su contraseña ha sido actualizada con éxito. Ahora puede iniciar sesión con su nueva contraseña.",

    "sendWhatsappVerification": "Enviar Código de Verificación Vía WhatsApp",
    "sendSMSVerification": "Enviar Código de Verificación Vía Mensaje",

    "modalTitleSuccess": "Código Reenviado Exitosamente",
    "modalSubtitleSuccess": "Puede solicitar un código OTP dos veces al día. Si excede el límite, por favor inténtelo de nuevo mañana. Gracias por utilizar nuestro servicio.",
    "modalTitleFailed": "Límite de Envío de Código",
    "modalSubtitleFailed": "Ha alcanzado el límite de sus solicitudes de código OTP para hoy. Por favor, inténtelo nuevamente mañana para obtener un nuevo código OTP o contáctenos."
  },
  "registerScreen": {
    "register": "Registrarse",

    "subPatent": "Al suscribirte a Jala, aceptas registering, you agree to ",
    "jalaPrivacyAndPolicy": "Términos de servicio y política de privacidad de JALA",
    "registerNow": "Regístrese ahora",
    "phoneDisclaimer": "Asegúrese de que el número de teléfono que ingresó sea correcto, ya que solo puede cambiar el número de teléfono una vez en 24 horas."
  },
  "initialSyncScreen": {
    "loading": "Espere por favor\ncargando datos..."
  },

  "registerForm": {
    "name": "Nombre completo",
    "phone": "Número de teléfono",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "passwordConfirmation": "Vuelva a escribir la contraseña",
    "type": "Ocupación",
    "occupation": "Como",
    "birthdate": "Fecha de nacimiento",
    "knowjalafrom": "¿De dónde supiste acerca de JALA?",

    "namePlaceholder": "Su nombre",
    "phonePlaceholder": " ",
    "emailPlaceholder": "Correo electrónico",
    "passwordPlaceholder": "Contraseña",
    "passwordConfirmationPlaceholder": "Vuelva a escribir la contraseña",
    "farmers": "Cultivador",
    "nonFarmers": "No Cultivador",
    "occupationPlaceholder": "Elegir",
    "birthdatePlaceholder": "Elegir",

    "passwordConfirmationDoesntMatch": "${path} no coincide",

    "social_media": "Redes Sociales (Facebook, Instagram, Tik Tok, Youtube)",
    "online_ads": "Anuncios en línea",
    "blog_or_article": "Blog/Artículo",
    "offline_attribute": "Atributo sin Conexión (Folleto, Catálogo, Banner)",
    "friend_recomendation": "Recomendación de amigo",
    "community": "Comunidad",
    "online_event": "Evento en línea",
    "offline_event": "Evento fuera de línea",
    "other": "Otro"
  },

  "profileScreen": {
    "profile": "Cuenta",
    "verified": "Verificado",
    "unverified": "inconfirmado",
    "editProfile": "Editar perfil",
    "farmProfile": "Granja conectada",
    "security": "Seguridad",
    "settingAccount": "Ajuste",
    "privacyMenu": "Política de privacidad",
    "choice": "Elección",
    "interesTitle": "Configuración de personalización",
    "language": "Idioma",
    "support": "Apoyo",
    "helpMenu": "Ayuda",
    "faq": "FAQ",
    "whatsapp": "Jala WhatsApp",
    "emailMenu": "Email",
    "appsTutorial": "JALA App Tutorial",
    "joinTelegram": "Join Telegram Group",
    "theOther": "Otros",
    "rateUs": "Rate Jala",
    "appInfo": "Información de la aplicación",
    "exitMenu": "Cerrar sesión",
    "changeLanguage": "Cambiar idioma",
    "messenger": "Facebook Messenger",
    "logoutTitle": "Comprobar antes de cerrar sesión",
    "logoutSubtitle": "Asegúrese de que los datos sin conexión sean '0' antes de salir de la aplicación. Los datos sin conexión que no se han cargado se pueden eliminar si cierra la sesión",
    "logoutButtonConfirm": "Desconectar",
    "logoutButtonCancel": "Atrás"
  },

  "settingAccount": {
    "setting": "Configuración",
    "changePassword": "Cambiar la contraseña",
    "delete": "Borrar cuenta",
    "resetOfflineDatabase": "Restablecer base de datos fuera de línea",
    "resetOfflineDatabaseWarn": "Perderá registros sin conexión no enviados.",
  },

  "changePasswordForm": {
    "currentPassword": "Contraseña anterior",
    "password": "Nueva contraseña",
    "passwordConfirmation": "Reescriba nueva contraseña",
    "success": "Contraseña cambiada correctamente",
    "oldPasswordError": "La contraseña actual no coincide",
    "failedInput": "Falló, inténtelo de nuevo",

    "currentPasswordPlaceholder": "Contraseña anterior",
    "passwordPlaceholder": "Nueva contraseña",
    "passwordConfirmationPlaceholder": "Reescriba nueva contraseña",

    "passwordConfirmationDoesntMatch": "${path} no coincide"
  },

  "deleteScreen": {
    "term1": "El ciclo de datos, el estanque y la granja se eliminarán y no podrá volver a acceder a ellos..",
    "term2": "La cuenta y sus datos privados serán eliminados.",
    "term3": "Ya no se conectará a otra granja.",
    "deletingAccount": "¿Estás seguro de que quieres eliminar esta cuenta?",
    "termDelete": "Si su cuenta es eliminada : ",
    "delete": "Eliminar",
    "deleteConfirm": "Confirmar contraseña",
    "agreement": "Entiendo y acepto todos los riesgos anteriores sobre la eliminación de la cuenta.",
    "disclaimer": "La cuenta eliminada no se puede restaurar de nuevo. Si está seguro, complete su contraseña para eliminar la cuenta.",
    "placeholder": "Confirmar contraseña"
  },

  "editProfileForm": {
    "header": "Cambiar el perfil",
    "photo": "Cambiar foto de perfil",
    "name": "Nombre completo",
    "email": "Correo electrónico",
    "phone": "Número de teléfono",
    "gender": "Género",
    "regionId": "Dirección",
    "save": "Ahorrar",
    "man": "Hombre",
    "woman": "Mujer",
    "takePhoto": "Toma una foto",
    "fromGallery": "De la galería",

    "namePlaceholder": "Nombre completo",
    "emailPlaceholder": "Dirección de correo electrónico",
    "phonePlaceholder": "Número de teléfono",
    "genderPlaceholder": "Seleccione Género",
    "regionIdPlaceholder": "Seleccione Dirección"
  },

  "connectedFarm": {
    "header": "Granja conectada",
    "as": "Rol",
    "member": "Miembro",
    "emptyTitle": "Sin granja aun",
    "emptySubtitle": "Crea tu granja o solicita que el propietario te invite.",
    "farmProfile": "Perfil de la Granja",
    "farmLabel": "Nombre de la Granja",
    "address": "Dirección",
    "area":"Area",
    "addMember": "Agregar Miembro",
    "owner": "Propietario",
    "admin": "Administrador",
    "operator": "Operador",
    "laboran": "Asistente de laboratorio",
    "viewer": "Espectador",
    "add": "Agregar Miembro",
    "roleId": "Rol",
    "roleIdPlaceholder": "Seleccionar rol",
    "info": "Información",
    "access1": "Editar Registro de Cultivo",
    "access2": "Ver Registro de Cultivo",
    "access3": "Acceso al gráfico de análisis (aplicación web)",
    "access4": "Ver y editar el registro de inventario (aplicación web)",
    "access5": "Exportar Reporte de Cultivo (aplicación web)",
    "access6": "Ver y editar registro financiero (aplicación web)",
    "access7": "Exportar informe financiero (aplicación web)",
    "access8": "Agregar y eliminar miembros",
    "access9": "Editar acceso de miembros",
    "changeAccess": "Editar",
  },

  "pondScreen": {
    "addFarm": "Crear granja",
    "emptyFarm": "Sin granja aun",
    "createPond": "Crear estanque",
    "addPond": "Agregar estanque",
    "emptyPond": "Sin estanque",
    "startCycle": "Iniciar ciclo",
    "cycleHistory": "Historial del ciclo",
    "ClosedAt": "Cerrado a",
    "age": "DdC",
    "temperature": "Temp",
    "do": "OD",
    "ph": "pH",
    "salinity": "salinidad",
    "weather": "clima",
    "color": "colorr"
  },

  "storybook": {
    "placeholder": "Placeholder",
    "field": "Field"
  },

  "graphScreen": {
    "header": "Grafico",
    "message": "Elija la granja, el estanque y\nel ciclo para mostrar la grafica"

  },

  "diseaseScreen": {
    "shrimpDisease": "Enfermedad del camarón",
    "diseaseSearchPlaceholder": "Buscar palabra clave de enfermedad",
    "listDisease": "Lista de enfermedades",
    "read": "Leer",
    "empty": "Vaya, Resultado no encontrado.\nUsar otra palabra clave",
    "mostSearch": "o ver la enfermedad más buscada"
  },

  "newsScreen": {
    "shrimpNews": "Noticias de camarones",
    "newsSearchPlaceholder": "Buscar noticias de camarones",
    "latestNews": "Últimas noticias",
    "allCategory": "Toda categoría",
    "other": "Ver otras",
    "search": "Resultado de búsqueda de '{{search}}'",
    "searchByCategory": "o buscar por categoría",
    "category": "Categoría"
  },

  "autoFeederScreen": {
    "title": "alimentador automático",

    "connect": "conectar",
    "mode": "Modo",
    "typeCommand": "Escriba el comando",
    "send": "Enviar",
    "failedToConnect": "Error al conectar"
  },

  "autoFeederPondCreateScreen": {
    "title": "Añadir alimentador automático",
    "successAddSubtitle": "Tu Asto ha sido agregado con éxito!",
    "successModalSubtitle": "Antes de usar Asto, es importante configurar la conexión, el modo de reproducción y también la ejecución de prueba"
  },

  "autofeederCreateQRScanScreen": {
    "title": "Escanear código QR",
    "description": "Apunte la cámara a la imagen del código qr impresa en el controlador asto",
    "unrecognizedModalTitle": "Código QR no reconocido",
    "unrecognizedModalSubtitle": "El código QR aún no está registrado en nuestra base de datos, intente escanear nuevamente."
  },

  "autoFeederPondCreateWizardScreen": {
    "connectionSetup": "Configuración de conexión",
    "modeSetup": "Configuración de modo",
    "testRunSetup": "Configuración de prueba",
    "connectAsto": "Conectar el Asto",
    "connectAstoSubtitle": "Cuando estés utilizando el Asto, necesitarás conectarlo a través de Bluetooth o una red WiFi",
    "connectAstoWifi": "Conectar el Asto con WiFi (opcional)",
    "connectAstoWifiSubtitle": "También puedes conectar el Asto a una red WiFi en la granja",
    "testRunSubtitle": "Prueba el controlador del Asto para asegurarte de que está conectado a tu Autofeeder",
    "testRunModalTitle": "¿El Autofeeder está funcionando?",
    "hold": "Mantén presionado para iniciar",
    "bluetooth": "Bluetooth",
    "bluetoothDisconnected": "Desconectado. Toca para conectarlo",
    "ssid": "SSID de WiFi",
    "password": "Contraseña de WiFi",
    "connect": "Conectar",
    "optional": "*Puedes omitir esta etapa",
    "modeSetupSubtitle": "Elige uno de los modos según las condiciones actuales de tu estanque",
    "normal": "Normal",
    "normalDescription": "Alimentación según un horario específico durante el día",
    "continue": "Continuar",
    "continueDescription": "Alimentación continua hasta el final del tiempo de alimentación",
    "timesPerDay": "Total de alimentaciones",
    "debit": "Debitar alimento",
    "intervalPeriod": "Duración de alimentación",
    "onTime": "Temporizador ON",
    "interval": "Intervalo de tiempo",
    "startTime": "Hora de inicio",
    "endTime": "Hora de finalización",
    "debitUnit": "gr/segundo",
    "intervalPeriodUnit": "minutos",
    "onTimeUnit": "segundos",
    "timesPerDayUnit": "veces al día",
    "debitError": "El mínimo de alimentaciones diarias es 5 y el máximo es 7",
    "intervalHelper": "Intervalo por sistema",
    "onHelper": "Temporizador ON por sistema",
    "timerOnInfo": "La duración de una rotación completa del motor",
    "successModalTitle": "Felicitaciones, has completado la configuración del Asto",
    "successModalSubtitle": "A continuación, serás dirigido para conocer las funciones de la característica del Asto",
    "infoTestRun": "La prueba se llevará a cabo según lo previsto",
    "infoTestRunOnTime": "Timer ON: {{onTime}} segundos",
    "throwingDistance": "Distancia de lanzamiento",
    "short": "Corto",
    "medium": "Medio",
    "long": "Largo",
    "manual": "Establecer duración de la rotación (manual)",
    "duration": "Duración de la ronda",
    "timesPerDayHelper": "Puedes cargar entre 1 y 7 veces/día",
    "distanceHelper": "La distancia de lanzamiento del alimento depende del tamaño del alimento."
  },

  "autoFeederPondDetailScreen": {
    "title": "Asto Detalle",

    "mode": "Modo",
    "debit": "Feed Debit",
    "throwDebit": "Feed Debit",
    "startTime": "Start Time",
    "endTime": "End Time",
    "onTime": "Timer ON",
    "timesPerDay": "Feed per Day",
    "timesPerPeriod": "Throw per Feeding",
    "intervalPerPeriod": "Throw Interval",
    "intervalPeriod": "Feed Duration",
    "duration": "Duration",
    "frequency": "Frequency",
    "quantity": "Alimentación",
    "interval": "Timer Interval",
    "onTimeOverride": "Manual Timer ON",
    "intervalOverride": "Manual Timer Interval",
    "lastOnAt": "Last ON",
    "previousOnAt": "Previous ON",
    "nextOnAt": "Next ON",

    "intervalShort": "Interval",
    "override": "Manual",

    "debitUnit": "gr/s",
    "throwDebitUnit": "gr/throw",
    "onTimeUnit": "s",
    "timesPerDayUnit": "times",
    "timesPerPeriodUnit": "times",
    "intervalPeriodUnit": "minute(s)",
    "intervalUnit": "minute(s)",

    "intervalUnitShort": "m",

    "today": "Hoy",
    "nextDay": "Next day",
    "date": "Date",
    "time": "Time",

    "feedData": "Cycle Feed Data",
    "openFeedData": "Open Feed Data",
    "setFeedData": "Use Feed Data",

    "portion": "Portion (kg)",
    "feedPortion": "Feed Portion",
    "feedPortionHelper": "Feed Portion 1 of %{total} Auto Feeder",

    "failedToConnect": "Error al conectar",
    "uploadOrResetFirst": "Upload or reset first",

    "normal": "Normal",
    "continuous": "Continuous",

    "feedTableTitle": "Tabla de alimentación",
    "feedCycleTitle": "Ciclo de datos de alimentación",
    "todayFeedTitle": "Feed de hoy",

    "weeklySchedule": "Programa de alimentación semanal",
    "detail": "Detalle(kg)",
    "detailInfo": "Los detalles dependen del tiempo de alimentación.",
    "intervalInfo": "Intervalo de tiempo entre rondas",
    "durationInfo": "Duración del motor por rotación",

    "feedCycleDataDescription": "Puede usar los datos de alimentación que se han ingresado en la función Entrada de alimentación",
    "disconnectedWarning": "Conexión perdida",
    "disconnectedWarningDescription": "No estas conectado con el Asto",

    "confirmationSaveTitle": "Guardar los datos?",
    "confirmationSaveSubtitle": "¿Estás seguro de que quieres guardar los datos?",
    "confirmationUploadTitle": "Subir datos?",
    "confirmationUploadSubtitle": "¿Estás seguro de que quieres subir los datos?",
    "confirmationResetTitle": "Reiniciar datos?",
    "confirmationResetSubtitle": "¿Estás seguro de que quieres restablecer los datos?",

    "intervalDataTitle": "Datos de intervalo",
    "feedWarning": "La cantidad de alimento en el tanque se está agotando, verifíquelo ahora!",

    "uploadWarning": "Hay cambios en los datos de ASTO que aún no han sido subidos.",
    "uploadData": "Cargar Datos",

    "feedDataTitle": "Alimentación Datos",
    "failedConnect": "Error de conexión. Toca para conectar.",

    "uploadBannerTitle": "Los datos no se han enviado a ASTO.",
    "uploadBannerSubtitle": "Sube cambios de datos para actualizar la configuración en el autofeeder.",
    "uploadBannerButton": "ENVIAR",
    "uploadSuccessTitle": "¡Subida Exitosa!",
    "uploadSuccessSubtitle": "La configuración se ha guardado exitosamente en ASTO",
    "sendToAsto": "Enviar a ASTO",

    "advancedSetting": "Configuración Avanzada",

    "calibrationTitle": "¿El feed no se está agotando como se esperaba?",
    "calibrationButton": "Ajustar el flujo de alimentación",
    "calibrationModalTitle": "Ajuste de descarga de alimentación",
    "calibrationModalSubtitle": "Ingrese datos según las condiciones y ajustaremos el flujo para la siguiente toma.",
    "calibrationChooseTitle": "Hoy, mi feed",
    "under": "Terminado antes",
    "over": "Aún queda",
    "actualEndTime": "Comida terminada a las",
    "actualEndTimeAsk": "¿A qué hora terminó?",
    "actualIntervalPeriod": "Duración de la alimentación terminada",
    "remainingQuantity": "Cantidad de alimento restante estimada",
    "expectedQuantity": "Total de alimento anterior",
    "confirmationTitle": "¿Son correctos los datos?",
    "confirmationButton": "Sí, es correcto",
    "changes": "Cambios:",
    "debitBefore": "Débito antes",
    "debitAfter": "Débito después",
    "cancelButton": "Volver",
    "successTitle": "¡Guardado con éxito!",
    "successSubtitle": "Se realizará el ajuste en la próxima entrega de comida.",
    "close": "Cerrar"
  },

  "autoFeederPondEditScreen": {
    "title": "Auto-feeder Configuración",

    "connection": "Connection",
    "general": "General",
    "normal": "Normal",
    "continuous": "Continuous",
    "misc": "Misc",

    "bluetooth": "Bluetooth",
    "wifi": "WiFi",
    "ssid": "SSID",
    "password": "Password",

    "mode": "Mode",
    "debit": "Feed Debit (gr/s)",
    "throwDebit": "Feed Debit (gr/throw)",
    "startTime": "Start Time",
    "endTime": "End Time",
    "onTime": "Timer ON (second(s))",

    "timesPerDay": "Times per Day",
    "timesPerPeriod": "Throw times per feeding",
    "intervalPerPeriod": "Throw interval (minute(s))",
    "intervalPeriod": "Feed duration (minute(s))",

    "onTimeUnit": "second(s)",

    "testRun": "Test Run",
    "clearSetting": "Clear Setting",
    "disconnect": "Disconnect",
    "delete": "Eliminar",

    "connected": "Connected",
    "disconnected": "Disconnected",
    "connecting": "Connecting...",
    "tapToReconnect": "Tap to Reconnect",
    "tapToConnect": "Tap to Connect",
    "tapToRefresh": "Tap to Refresh",

    "failedToConnect": "Failed to Connect",
    "continuousSetting": "Cài Đặt Cơ Bản Cho Chế Độ Liên Tục",
    "normalSetting": "Cài Đặt Cơ Bản Cho Chế Độ Bình Thường"
  },

  "autoFeederPondActivityListScreen": {
    "title": "Auto Feeder Activity",
    "subtitle": "within a week"
  },

  "autoFeederPondForm": {
    "farmId": "Granja",
    "pondId": "Estanque",
    "id": "ID",
    "name": "Name",
    "mode": "Mode",
    "updatedAt": "Updated At",
    "autoFeeder": "Auto Feeder",

    "farmIdPlaceholder": "Select Farm",
    "pondIdPlaceholder": "Select Pond",
    "idPlaceholder": "ID",
    "namePlaceholder": "Name",
    "modePlaceholder": "Mode",
    "updatedAtPlaceholder": "Updated At",
    "autoFeederPlaceholder": "Select Auto Feeder",

    "enableBluetoothTitle": "Habilitar Bluetooth",
    "enableBluetoothSubtitle": "Una vez que Bluetooth esté activo, puede continuar agregando asto a su dispositivo.",
    "enableBluetoothConfirm": "PERMITIR",
    "enableBluetoothCancel": "MÁS TARDE"
  },

  "farmPondListScreen": {
    "header": "Crear estanque",
    "title": "Estanques",
    "lastUpdate": "última actualización %{datetime}",
    "noUpdate": "sin actualización en la última semana",
    "noRecord": "Sin ciclos activos",
    "number": "Estanques totales",
    "pondName": "Nombre del estanque",
    "total": "{{pond}} estanque",
    "pondTooltip": "Crea un estanque para que puedas anotar los datos inmediatamente.",
    "createCycle": "Inicia ciclo para disfrutar de los servicios de Jala",

    "initialDataLoading": "Carga de Datos Inicial"
  },

  "farmAutoFeederPondListScreen": {
    "title": "Auto Feeders",
    "asto": "Asto",
    "addAsto": "Añadir Asto",
    "astoList": "Lista Asto",

    "feed": "Alimento: %{feed} kg",
    "noDevices": "Sin dispositivos",
    "mode": "Modo: %{mode}",
    "todayFeed": "Feed de hoy",
    "lastUpdate": "Última actualización",
    "lastUploaded": "Último subido",
    "playMode": "Modo de juego",
    "nextDayFeed": "Alimentación al día siguiente",

    "farm": "Granja",
    "normal": "Normal",
    "continuous": "Continuous",

    "emptyStateTitle": "No has añadido Asto",
    "emptyStateSubtitle": "Para usar esta función, debe agregar Asto.",
    "emptyStateButton": "Añadir Asto",

    "orderTitle": "Todavía no tienes Asto?",
    "orderButton": "Ordenar ahora",

    "cycleClosedTitle": "No hay ciclo activo",
    "cycleClosedSubtitle": "Necesitas crear un nuevo ciclo.",
    "cycleLaterButton": "MÁS TARDE",
    "createCycleButton": "CREAR CICLO"
  },
  "measurementCreateScreen": {
    "title": "Agregar Datos"
  },
  "measurementEditScreen": {
    "title": "Editar Datos"
  },
  "feedCreateScreen": {
    "title": "Agregar Datos"
  },
  "feedEditScreen": {
    "title": "Editar Datos"
  },
  "feedingTrayControlCreateScreen": {
    "title": "Agregar Datos"
  },
  "feedingTrayControlEditScreen": {
    "title": "Editar Datos"
  },

  "createPondForm": {
    "farm": "Crear estanques para granja",
    "prefix": "Prefijo del nombre del estanque",
    "name":"Nombre del estanque",
    "length":"Longitud (m)",
    "width":"Ancho (m)",
    "wide": "Amplio (m2)",
    "depth": "Profundidad (m)",
    "type": "Tipo de estanque",
    "square": "Cuadrado",
    "circle": "Circulo",
    "diameter": "Diameter (m)",
    "nameError": "Nombre ya usado en otro estanque",
    "prefixDisclaimer": "La numeración seguirá automáticamente el número de estanques",
    "inputTitle": "Lista de estanques",
    "inputDisclaimer": "Cambie el área del estanque de acuerdo con el real para que el cálculo de la estimación de Jala sea más apropiado.",

    "namePlaceholder":"Nombre del estanque",
    "lengthPlaceholder":"-",
    "widthPlaceholder":"-",
    "widePlaceholder": "-",
    "depthPlaceholder": "-",
    "diameterPlaceholder": "-",
    "prefixPlaceholder": "Prefijo del nombre del estanque",
  },

  "quickInput": {
    "farming": "Cultivo",
    "daily": "Diario",
    "LabTest": "Prueba de laboratorio",
    "Others": "Otros",
    "startCycle": "Iniciar ciclo",
    "sampling": "Muestreo",
    "harvest": "Cosecha y Parcial",
    "closeCycle": "Cerrar ciclo",
    "createFarm": "Crear granja",
    "createPond": "Crear estanque",
    "feed": "Alimentación",
    "waterQuality": "Calidad del agua",
    "treatment": "Tratamiento",
    "feedingTray": "Canasta de alimentación",
    "chemical": "Químico",
    "microbiology": "Microbiología",
    "plankton": "Plancton",
    "disease": "Enfermedad",
    "mortality": "Mortalidad",
    "quickInputTitle": "Información rápida"
  },

  "phoneInput": {
    "chooseCountry": "Seleccionar país"
  },

  "picker": {
    "choose": "Elegir"
  },

  "bluetoothPicker": {
    "scanQr": "Scan QR"
  },

  "predictions": {
    "activePond": "Estanques activos",
    "#": "#",
    "biomasPrediction": "Predicción de biomasa",
    "feedCumulative": "Feed acumulativo",
    "SrPrediction": "Predicción TS",
    "SeliingPricePrediction": "Predicción del precio de venta"
  },

  "monitoring": {
    "batch": "loteh",
    "label": "Seleccione Lote",
    "cyclesCount": "Ciclo(s)",
    "disclaimer": "Complete sus datos para que la estimación en la aplicación esté más cerca de los datos reales. ¿Alguna queja sobre la aplicación Jala?",
    "feedback": "Danos su opinión",
    "weight": "PP (g)",
    "size": "Talla",
    "totalWeight": "Biomasa total (kg)",
    "harvestAccumulationWeight": "Cosecha acumulada (kg)",
    "adg": "GDP (g)",
    "feedAccumulation": "Alimentación total (kg)",
    "survivalRate": "Estimación de TS (%)",
    "fcr": "Estimación FCR",
    "disclaimerMonitoring": "Datos completos de alimentación y muestreo para una estimación más precisa",
    "disclaimerMonitoringBefore30": "Datos de alimentación completos para estimaciones más precisas",
    "seePond": "Ver estanque",
    "parameter": "Parámetro",
    "actual": "Real (DdC)",
    "estimation": "Estimación de hoy",
    "pondPopulate": "Población de la piscina (%)",
    "empty": "Datos no encontrados"
  },

  "samplingInput": {
    "title":"Agregar Datos de Muestreo",
    "inputTitle": "Muestreo"
  },

  "treatmentInput": {
    "title":"Agregar Datos de Tratamiento"
  },

  "harvestInput": {
    "title":"Agregar Datos de Cosecha",
    "inputTitle": "Cosecha"
  },

  "cycleDiseaseInput": {
    "title": "Agregar Datos de Enfermedades"
  },

  "chemical": {
    "header": "Químico",
    "date": "Fecha (DdC)",
    "Ammonia": "NH3",
    "Nitrit": "NO2",
    "Alkalinity": "Alcalinidad",
    "more": "Más",
    "inputTitle":"Agregar Datos Químicos",
    "changeParam": "Cambiar la lista de parámetros"
  },

  "chemicalForm" : {
    "farmId": "Granja",
    "pondId": "Estanque",
    "header": "Analisis Quimico",
    "measuredDate": "Fecha",
    "ammonia": "Amoníaco (NH3) (ppm)",
    "nitrit": "Nitrito (NO2) (ppm)",
    "alkalinity": "Alcalinidad (ppm)",
    "ammonium": "Amonio (NH4) (ppm)",
    "nitrat": "Nitrato (NO3) (ppm)",
    "carbonat": "Carbonato (CO3) (ppm)",
    "bicarbonat": "Bicarbonato (HCO3) (ppm)",
    "hardness": "Dureza (ppm)",
    "calcium": "Calcio (Ca) (ppm)",
    "magnesium": "Magnesio (Mg) (ppm)",
    "phosphate": "Fosfato (PO4) (ppm)",
    "tom": "Materia Organica Total (TOM) (ppm)",
    "orp": "Potencial de reducción de oxidación (ORP) (ppm)",

    "farmIdPlaceholder":"Seleccione Granja",
    "pondIdPlaceholder": "Seleccione Estanque",
    "measuredDatePlaceholder": "Seleccione Fecha",
    "ammoniaPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "nitratPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-"
  },

  "pondProfileForm": {
    "setting": "ajuste del estanque",
    "delete": "Eliminar estanque",
    "name": "Nombre del estanque",
    "rfid": "Número RFID (Opcional)",
    "rfidSubtitle": "RFID es una tarjeta que recibiste cuando compraste Baruno, dentro de ella hay códigos de 8 dígitos que puedes registrar para identificar el estanque.",
    "rfidTitle": "Número RFID",
    "length": "Longitud (m)",
    "width": "Ancho (m)",
    "area":"Área (m2)",
    "diameter": "Diámetro (m)",
    "deep": "Profundo (m)",
    "createdAt": "Fecha de creacion",
    "feedingTrayCount": "Bandeja de alimentación",
    "type": "Tipo de estanque",
    "square": "Cuadrado",
    "circle": "Redondo",
    "existingName": "Este nombre ya se usa en su otro estanque",
    "warning": "Cambiar el área del estanque no afectará los cálculos de predicción para el ciclo anterior o en curso, pero afectará las predicciones para el siguiente ciclo.",
    "rfidNotFound": "No se han encontrado resultados",
    "rfidLabel": "RFID",
    "success": "Datos guardados exitosamente",
    "failed": "No se pudieron guardar los datos, verifique su conexión a Internet e intente nuevamente",
    "editPondDesc": "Cambiar el área del estanque no afectará los cálculos de predicción para el ciclo anterior o en curso, pero afectará las predicciones para el siguiente ciclo.",
    "visit": "*Visitar",

    "namePlaceholder": "Nombre del estanque",
    "rfidPlaceholder": "Ingrese 8 letras de código",
    "lengthPlaceholder": "-",
    "widthPlaceholder": "-",
    "areaPlaceholder":"-",
    "deepPlaceholder": "-",
    "diameterPlaceholder": "-",
    "createdAtPlaceholder": "Seleccionar datos",
    "feedingTrayCountPlaceholder": "Seleccionar bandeja de alimentación",

    "deleteModalTitle": "¿Estás seguro de que quieres eliminar el estanque?",
    "deleteModalSubtitle": "Si estás seguro, escribe ",
    "deleteModalSubtitleLast": "para confirmar el estanque que deseas eliminar.",
    "pondNamePlaceholder": "Escribe el nombre del estanque",
    "confirmDeleteButton": "SÍ, ELIMINAR",
    "cancelDeleteButton": "CANCELAR",
    "modalErrorMessage": "Escribe “{{pond}}”"
  },

  "cycleHistoryScreen": {
    "header": "Historial del ciclo",
    "days": "dias",
    "kg": "kg",
    "percent": "%",
    "age": "Edad",
    "harvest": "Cosecha",
    "seed": "Larvas",
    "fcr": "FCR",
    "size": "Talla",
    "survival": "TS"
  },

  "personalisationScreen": {
    "header": "Configuración de personalización",
    "PersonalizationTitle": "Configure la vista de la página de inicio según lo que esté buscando",
    "PersonalizationSubtitle": "Para configurar la vista, elija uno o más intereses a continuación.",
    "button": "Siguiente"

  },

  "verificationScreen": {
    "title": "verifica tu numero de telefono",
    "subtitle": "Verifique su número de teléfono {{phone}} para obtener el código OTP.",
    "subtitleOld": "Ayúdenos a autenticar su número de teléfono ingresando el código OTP que le enviamos a {{phone}}",
    "warningOld": "Verifique su número de teléfono dentro de {{day}} días {{hour}} hora",
    "verificationInfo": "Puede usar Jala inmediatamente después de verificar su número de teléfono",
    "codeVerificationError": "El código es incorrecto o vencido.",
    "placeholderOTP": "Código OTP de 6 dígitos",
    "resendOTP": "Reenviar OTP",
    "cantVerify": "¿No puedo obtener el código OTP?",
    "contactUs": " Contáctenos",
    "verificationButton": "Ingrese el código OTP",
    "inputBeforeExpired": "Ingrese el código OTP en {{seconds}} segundos",
    "changePhoneTitle": "Cambiar número de teléfono",
    "changePhoneSubtitle": "Enviaremos un nuevo código OTP al número de teléfono que ingresó a continuación.",
    "verification": "Verificación",
    "verificationWarning": "Verifique su número de teléfono dentro de {{day}} días",
    "inputPhoneTitle": "Ingresa número telefónico",
    "inputPhoneSubtitle": "Ayúdenos a verificar su cuenta, comience ingresando su número de teléfono.\nSe enviará un código OTP por SMS.",
    "changeNumberButton": "Cambiar el número de teléfono y reenviar OTP",
    "verifExpired": "Verificación completa para continuar con el panel",
    "whatsappMessageVerification": "Please help me verify my phone number {{phoneNumber}}",
    "whatsappMessageVerificationEmail": "Please help me verify my email {{email}}",
    "changePhone": "Cambiar telefono",
    "phoneVerificationTitle": "Verificación de Teléfono",
    "phoneChangeTitle": "Cambiar de Teléfono",

    "phoneWarning": "No se puede cambiar el número porque se cambió en las últimas 24 horas",
    "phoneError": "Número de teléfono no válido",
    "phoneDisclaimer": "Solo puede cambiar su número una vez en 24 horas. Contáctenos para otras preguntas.",

    "verificationFailed": "Fallo en la verificación",
    "OTPLimited": "No se pudo obtener la OTP\nUse otro número de teléfono o Contáctenos"
  },

  "autoFeederPond": {
    "plural": "auto feeder ponds",
    "singular": "auto feeder pond",

    "id": "ID",
    "pond_id": "pond ID",
    "auto_feeder_address": "address",
    "name": "name",
    "mode": "mode",
    "debit": "debit",
    "state": "state",

    "startTime": "start time",
    "endTime": "end time",
    "onTime": "timer ON",
    "feeds": "feeds",
    "uploadedAt": "uploaded at",
    "lastOnAt": "last ON at",

    "updated": "updated",
    "uploaded":"uploaded",
    "created": "created"
  },

  "infoAppScreen": {
    "title": "Información de la aplicación",
    "header": "Aplicación de gestión de cultivo de camarón",
    "thanks": "Gracias al probador beta",
    "madeIn": "Hecho en Indonesia",
    "credit": "© 2022 PT JALA Akuakultur Lestari Alamku"

  },

  ...components,
  ...forms,
  ...models,
  ...screens,
  ...commons,
  yup,

  "privacyPolicy": "Política de Privacidad",

  "thunderStorm": "Tormenta",
  "rain": "Lluvia",
  "drizzle": "Llovizna",
  "cloudy": "Nublado",
  "sunnyCloudy": "Soleado y Nublado",
  "sunny": "Soleado",
  "scorching": "Caliente",
  "none": "None",

  "yellow": "Amarillo",
  "yellowGreen": "Amarillo verde",
  "brown": "Café",
  "brownGreen": "Café Verde",
  "darkBrown": "Café Oscuro",
  "lightBrown": "Café Claro",
  "brownRed": "Café Rojo",
  "green": "Verde",
  "greenBrown": "Verde Café",
  "greenBlue": "Verde Azul",
  "darkGreenBrown": "Verde Café Oscuro",
  "darkGreen": "Verde Oscuro",
  "black": "Negro",

  "Search": "Búsqueda",
  "Clear": "claro",
  "Close": "Cerca",
  "Finished": "Acabado",
  "Please Wait": "Espere por favor",
  "Network Error": "Error de red",
  "language": "Idioma",
  "total": "Total",
  "average": "Average",
  "million": "Million",
  "doc": "DdC",
  "Today": "Hoy",
  "SRWithPercent": "TS(%)",
  "Size": "Talla",
  "Biomass": "Biomasa",
  "harvest": "Cosecha",
  "cycle": "Ciclo",
  "date": "Fecha",
  "time": "Tiempo",
  "noPond": "Sin estanque",
  "save": "Guardar",
  "connect": "Connect",
  "add": "Agregar",
  "edit": "Editar",
  "delete": "Eliminar",
  "cancel": "Cancelar",
  "reset": "Reiniciar",
  "upload": "Cargar",
  "uploading": "Subiendo",
  "override": "Override",
  "failed": "Fallido",
  "success": "Éxito",
  "offlineModeContent": "Los datos se almacenan temporalmente en su dispositivo. Cargue datos inmediatamente cuando la señal sea suficiente.",
  "offlineModeWeakConnection": "Conexión débil",
  "Errors": "Errores",
  "farmingSummary": "Tóm tắt thông tin nuôi trồng",
  "cycleHistory": "Lịch sử chu kỳ",
  "pondProfile": "Cài đặt ao",
  "cycleProfile": "Cài đặt chu kỳ",
  "searchPondPlaceholder": "Buscar Estanque...",
  "paramTooltip": "Haga clic aquí para ingresar otro parámetro de datos",

  "and": "y",
  "noData": "sin datos",

  "areYouSureYouWantTo": "¿Estás seguro de que quieres hacer %{something}?",

  "LongNet": "Neto (cantidad que ordenó)",
  "LongGross": "Bruto (cantidad recibida del laboratorio)",
  "LongActual": "Real (cantidad real contabilizada)",

  "Net": "Neto",
  "Gross": "Bruto",
  "Actual": "Real",

  "cantBeZero": "no puede ser 0",
  "validationInput": "Este campo es obligatorio",
  "otherParameters": "otros parámetros",
  "minPassword": "La contraseña debe tener al menos 6 caracteres",
  "cantBeMinus": "La entrada no puede ser inferior a 0",

  "filter": "Filtrar",
  "addNote": "Notes",

  "now": "ahora",

  "fetchingData": "Obteniendo los datos...",
  "offline": "Registro sin conexión almacenado",

  "changeLanguage": {
    "title": "Opción de idiomas",
    "Indonesia": "Bahasa Indonesia (ID)",
    "english": "English (EN)",
    "vietnamese": "Tiếng Việt (VN)",
    "espanol": "Español (ES)",
  },

  "checkLink": "Consulte este enlace: {{url}}",
  "shareDiseaseTitle": "Información sobre la enfermedad del camarón: {{disease}}",
  "failedShared": "No se pudo compartir. Vuelve a intentarlo más tarde.",
  "shareNewsTitle": "¿Leerías este artículo de Jala? {{news}}.",
  "sharePriceTitle": "Actualizar {{date}}, precio del camarón (talla 100) - {{region}}",
  "copiedToClipboard": "Copiado al portapapeles",

  "posts": {
    "read_complete_article_only_on": "leer el artículo completo solo enn"
  },

  "notifications": {
    "infoHeader": "Precio del camarón",
    "farmingHeader": "Agricultura",
    "priceNotificationTitle": "Nuevo arroz de camarón en la región",
    "readAll": "Marcar todo como leido",
    "waitingForLoad": "Cargando Nuevas Notificaciones",
    "emptyNotification": "Nuevas notificaciones vacías",
    "refreshPage": "Actualizar página",
  },

  "NewFeature": "Nueva caracteristica! {{featureName}}",
  "AlertFailedTitle": "Fallido",
  "AlertFailedAuthSubtitle": "error de inicio de sesion",
  "AlertFailedRegisSubtitle": "Registro fallido",
  "AlertWrongInput": "Correo electrónico / contraseña inválido",
  "AlertServerUnreachable": "Servidor inalcanzable",
  "AlertServerFail": "Disculpe, hay un problema con el servidor.",
  "AlertUserNotFound": "Usuario no encontrado, asegúrese de que su correo electrónico y/o contraseña sean correctos",
  "AlertUserUnauthenticated": "Usuario no encontrado, por favor regístrese o vuelva a iniciar sesión",
  "AppleSignInNotSupported": "Lo sentimos, su versión de iOs no pudo iniciar sesión con el ID de Apple. Actualice su versión de iOs o inicie sesión con otra opción",

}
